"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mailboxActions = exports.addMessages = exports.addMessage = exports.setCurrentConversationId = exports.addConversations = exports.removeConversation = exports.addConversation = exports.setUnreadCounts = exports.setOwnProfileGid = exports.SetMessagesLoadingAction = exports.AddMessagesAction = exports.AddMessageAction = exports.SetConversationsLoadingAction = exports.SetConversationIdAction = exports.RemoveConversationAction = exports.AddConversationsAction = exports.AddConversationAction = exports.SetUnreadCounts = exports.SetOwnProfileGid = void 0;
const typesafe_actions_1 = require("typesafe-actions");
// Other
exports.SetOwnProfileGid = 'set_own_profile_gid';
exports.SetUnreadCounts = 'set_unread_counts';
// Conversations
exports.AddConversationAction = 'add_conversation';
exports.AddConversationsAction = 'add_conversations';
exports.RemoveConversationAction = 'remove_conversation';
exports.SetConversationIdAction = 'set_conversation_id';
exports.SetConversationsLoadingAction = 'set_conversations_loading';
// Messages
exports.AddMessageAction = 'add_message';
exports.AddMessagesAction = 'add_messages';
exports.SetMessagesLoadingAction = 'set_messages_loading';
// Other
const setOwnProfileGid = (payload) => typesafe_actions_1.action(exports.SetOwnProfileGid, payload);
exports.setOwnProfileGid = setOwnProfileGid;
const setUnreadCounts = (payload) => typesafe_actions_1.action(exports.SetUnreadCounts, payload);
exports.setUnreadCounts = setUnreadCounts;
// Conversations
const addConversation = (payload) => typesafe_actions_1.action(exports.AddConversationAction, payload);
exports.addConversation = addConversation;
const removeConversation = (payload) => typesafe_actions_1.action(exports.RemoveConversationAction, payload);
exports.removeConversation = removeConversation;
const addConversations = (payload) => typesafe_actions_1.action(exports.AddConversationsAction, payload);
exports.addConversations = addConversations;
const setCurrentConversationId = (payload) => typesafe_actions_1.action(exports.SetConversationIdAction, payload);
exports.setCurrentConversationId = setCurrentConversationId;
// Messages
const addMessage = (payload) => typesafe_actions_1.action(exports.AddMessageAction, payload);
exports.addMessage = addMessage;
const addMessages = (payload) => {
    return typesafe_actions_1.action(exports.AddMessagesAction, payload);
};
exports.addMessages = addMessages;
exports.mailboxActions = {
    addConversation: exports.addConversation,
    addConversations: exports.addConversations,
    addMessage: exports.addMessage,
    addMessages: exports.addMessages,
    removeConversation: exports.removeConversation,
    setCurrentConversationId: exports.setCurrentConversationId,
    setOwnProfileGid: exports.setOwnProfileGid,
    setUnreadCounts: exports.setUnreadCounts,
};
